import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { PGET, DELETE, PUT } from "../../../api/adminApi";
import { CustomSvg } from "../../../utils/CustomSvg";
import { getDateTime } from "../../../utils/Dates";
import { toast } from "react-toastify";
import { CheckSquare } from "react-feather";
import { Image } from "react-bootstrap";

export default function BulkNotification() {
  const [items, setItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    +localStorage.getItem("currentPageBulkNotification") || 0,
  );

  const paginate = (data) => {
    setCurrentPage(data.selected);
    localStorage.setItem("currentPageBulkNotification", data.selected);
  };

  async function getItems() {
    const data = await PGET(
      "/services/admin/api/bulk-notification-pageList",
      true,
      {
        page: currentPage,
        size: 10,
      },
    );
    setPageCount(Math.ceil(data.headers["x-total-count"] / 10));
    setItems(data.data);
  }

  async function deleteItem(id) {
    if (window.confirm("Вы действительно хотите удалить?")) {
      const response = await DELETE(
        `/services/admin/api/bulk-notification/${id}`,
      );
      if (response?.success) {
        toast.success("Успешно удалено");
        getItems();
      }
    }
  }

  async function approveItem(id) {
    if (window.confirm("Вы действительно хотите подтвердить рассылку?")) {
      const response = await PUT(
        `/services/admin/api/bulk-notification-approve/${id}`,
      );
      if (response?.success) {
        toast.success("Рассылка подтверждена");
        getItems();
      }
    }
  }

  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  return (
    <div
      className="br-5 card"
      style={{ background: "#eef1ff", marginTop: "-0.9rem", height: "100vh" }}
    >
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bold fs-3 mb-1">
            Рассылки по номерам
          </span>
        </h3>
        <div className="card-toolbar">
          <Link
            to="/admin/bulk-notification-create"
            className="btn btn-sm btn-light-primary"
          >
            <CustomSvg
              path="/icons/duotune/arrows/arr075.svg"
              className="svg-icon-3"
            />
            Добавить новый
          </Link>
        </div>
      </div>
      <div className="px-3 pb-4 pt-2">
        <div style={{ overflow: "auto", maxHeight: "75vh" }}>
          <table className="table bg-white table-rounded p-0 border gy-4 gs-7">
            <thead className="position-sticky top-0 rounded">
              <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                <th
                  style={{
                    width: "30px",
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                    borderTopLeftRadius: "8px",
                  }}
                  className="text-white text-center"
                >
                  №
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Заголовок
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Сообщение
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Телефоны
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Картинка
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Время создания
                </th>
                <th
                  className="text-center text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Статус
                </th>
                <th
                  className="text-start text-white"
                  style={{
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                    borderTopRightRadius: "8px",
                  }}
                >
                  Действия
                </th>
              </tr>
            </thead>
            <tbody style={{ overflowX: "auto" }}>
              {items.map((item, index) => {
                return (
                  <tr key={item.id} className="borderBottom">
                    <td className="text-center">
                      {currentPage === 0
                        ? index + 1
                        : currentPage * 10 + index + 1}
                    </td>
                    <td className="text-start">{item.titleText}</td>
                    <td className="text-start">{item.messageText}</td>
                    <td
                      className="text-start"
                      style={{
                        maxWidth: "200px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {Array.isArray(item.phones)
                        ? item.phones.join(", ")
                        : item.phones}
                    </td>
                    <td className="text-start">
                      {item.imageUrl ? (
                        <Image
                          src={
                            item.imageUrl.startsWith("http")
                              ? item.imageUrl
                              : "https://bo.akfacomfort.uz" + item.imageUrl
                          }
                          style={{ width: 50, height: 50, objectFit: "cover" }}
                          thumbnail
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-start">
                      {getDateTime(item.createdTime)}
                    </td>
                  <td className="text-start w-10">
                      <b
                        style={{
                          whiteSpace: "nowrap",
                        }}
                        className={`p-2 badge rounded font-weight-500 d-block ${
                          item.status === 0 || item.status === "0" || item.status === "NEW" || item.status === "New"
                            ? "badge-warning"
                            : item.status === 1 || item.status === "1" || item.status === 2 || item.status === "2" || item.status === "APPROVED" || item.status === "Approved" || item.status === "SENT" || item.status === "Sent"
                              ? "badge-success"
                              : item.status === 3 || item.status === "3" || item.status === "FAILED" || item.status === "Failed" || item.status === "ERROR" || item.status === "Error"
                                ? "badge-danger"
                                : "badge-light-primary"
                        }`}
                      >
                        {item.status === 0 || item.status === "0" || item.status === "NEW" || item.status === "New"
                          ? "В ожидании"
                          : item.status === 1 || item.status === "1" || item.status === 2 || item.status === "2" || item.status === "APPROVED" || item.status === "Approved" || item.status === "SENT" || item.status === "Sent"
                            ? "Отправлен"
                            : item.status === 3 || item.status === "3" || item.status === "FAILED" || item.status === "Failed" || item.status === "ERROR" || item.status === "Error"
                                ? "Ошибка"
                                : item.status}
                      </b>
                    </td>
                    <td className="text-end">
                      <div className="d-flex justify-content-end gap-2">
                        <Link
                          to={`/admin/bulk-notification-update/${item.id}`}
                          className="btn btn-icon shadow-sm btn-active-color-primary btn-sm me-2"
                          title="Редактировать"
                        >
                          <CustomSvg path='/icons/duotune/art/art005.svg' className='svg-icon-3'/>
                        </Link>
                        <button
                          onClick={() => deleteItem(item.id)}
                          className="btn btn-icon shadow-sm btn-active-color-danger btn-sm me-2"
                          title="Удалить"
                        >
                          <CustomSvg
                               path='/icons/duotune/general/gen027.svg'
                               className='svg-icon-3'
                           />
                        </button>
                        {item.status !== 1 &&
                          item.status !== "1" &&
                          item.status !== 2 &&
                          item.status !== "2" &&
                          item.status !== "APPROVED" &&
                          item.status !== "Approved" &&
                          item.status !== "SENT" &&
                          item.status !== "Sent" && (
                            <button
                              onClick={() => approveItem(item.id)}
                              className="btn btn-icon shadow-sm btn-active-color-success btn-sm"
                              title="Подтвердить"
                            >
                              <CheckSquare color={"#5C3EBA"} size={16}/>
                            </button>
                          )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {pageCount > 1 && (
          <ReactPaginate
            forcePage={currentPage}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={1}
            onPageChange={paginate}
            containerClassName={"pagination"}
            activeClassName={"bg-dark text-white"}
            pageClassName={"page-item box-shadow br-5"}
          />
        )}
      </div>
    </div>
  );
}
